import {
  FETCH_STORE_LIST,
  RESET_STORE_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: { total: 0, offset: 0, limit: 10 },
};

const storeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_LIST:
      return { list: action.payload, others: action.others };
    case RESET_STORE_LIST:
      return initialState;
    default:
      return state;
  }
};

export default storeListReducer;
